import { useRequest } from 'ahooks'
import { useBtc } from '@/context/BtcContext'

interface Inscription {
  inscriptionId: string
  inscriptionNumber: string
  amount: string
}

const useInscirptionOfUser = (ticker: string) => {
  const { isConnected, address } = useBtc()

  return useRequest(
    async () => {
      const resp = await fetch(
        `https://api.multibit.exchange/vendor/api/btc/address-balance-details?address=${address}&token=${ticker}`,
      )
      const jsonResp = await resp.json()
      return jsonResp?.data?.[0]?.transferBalanceList as Inscription[]
    },
    {
      ready: isConnected && !!address && !!ticker,
      refreshDeps: [address, ticker],
    },
  )
}

export default useInscirptionOfUser
